import { Link, useSearchParams } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';

const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  return (
    <div className="min-h-screen pt-32 pb-24 flex items-center justify-center" data-testid="checkout-success-page">
      <div className="max-w-md mx-auto px-6 text-center">
        <div className="w-16 h-16 mx-auto mb-8 border-2 border-bb-gold flex items-center justify-center">
          <Check className="w-8 h-8 c-gold" />
        </div>
        <h1 className="t-headline text-4xl c-cream mb-4">Thank You</h1>
        <p className="t-body c-muted mb-2">Your order has been placed successfully.</p>
        {orderId && <p className="t-label c-gold text-xs mb-6">Order #{orderId.slice(0, 8).toUpperCase()}</p>}
        <p className="t-body c-muted text-sm mb-8">We'll review your order and follow up via email shortly.</p>
        <Link to="/products"><button className="btn-primary" data-testid="success-shop">Continue Shopping <ArrowRight className="w-4 h-4" /></button></Link>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;
